import React from 'react'

const AboutUs = () => {
  return (
    <div className='lg:flex block justify-between'>
    
     <img className='lg:w-1/3 w-full' src="./images/homepage1 images/about us img.png" alt="" />
     <div className='bg-gray-100 lg:px-32 lg:py-20 lg:w-2/3 w-full py-10'>
      <h1 className='font-light text-4xl text-[#0404c2] fonthead text-6xl ' >About Us</h1>
       
      <h3 className='mt-10' >We are team of passionate event organizers who strive to create unforgettable experiences for out attendeed</h3>
      <br />
      <h3>
      Our team has years of experience in the industry and we are committed to bringing you the best events possible. From the planning stages
      to the execution,we work tirelessly to ensure htta evey detail is taken care of. 
      </h3>
    <br />
      <h3>
      We are dedicated to creating a safe and inclusive enviroment for all attendees,
      regardless of background or identity.Our events are designed to bring people
      togehterad foster a sense of community.

      </h3>
     </div>
    </div>
  )
}

export default AboutUs